import React from 'react';
import { GroupConsumer } from '../../../../contexts/GroupContext';
/* Content Components */
import Feed from '../../../Content/Feed/Feed';
import { groupActions } from '../../../Includes/GroupActionTypes';
import AboutCard from '../../AboutCard/AboutCard';
import GroupCTA from '../../Elements/GroupCTA/GroupCTA'; // eslint-disable-line import/no-named-as-default
import RulesCard from '../../RulesCard/RulesCard';

/* Styles */
import './HomeView.scss';

export default class HomeView extends React.PureComponent {
    render() {
        return (
            <div className="component-Groups-View-HomeView">
                <GroupConsumer>
                    {({
                        group,
                        userRelation,
                        hasPermission,
                        acceptInvitation,
                        isMember,
                    }) => {
                        if (hasPermission(groupActions.VIEW_CONTENTS)) {
                            return (
                                <Feed
                                    feedGroup="GroupFeed"
                                    feedGroupId="master"
                                    feedType="masterFeed"
                                    location="groupFeed"
                                    communityGroupHash={group.hash}
                                    hideReactionBar={
                                        !hasPermission(
                                            groupActions.POST_CONTENTS
                                        )
                                    }
                                    userRelation={userRelation}
                                />
                            );
                        }

                        return (
                            <div className="closed-group-home">
                                <AboutCard
                                    displayText={group.aboutGroup}
                                    locationList={group.locations}
                                />

                                {group.rules && (
                                    <RulesCard displayText={group.rules} />
                                )}

                                <div className="cta-btn-wrapper">
                                    <GroupCTA
                                        group={group}
                                        userRelation={userRelation}
                                        acceptInvitation={acceptInvitation}
                                        isMember={isMember}
                                    />
                                </div>
                            </div>
                        );
                    }}
                </GroupConsumer>
            </div>
        );
    }
}
